import styled from "@emotion/styled";
import { TextInputRootBase } from "./TextInputRootBase";
import { TextInputRootBoxProps, formInputTheme, getBorderColor } from "./formInputTheme";

export const TextInputRootUnderline = styled(TextInputRootBase)<TextInputRootBoxProps>`
    border: ${(props) => (props.themeMode === "oldestar" ? 1 : 2)}px solid transparent;
    border-bottom: solid ${getBorderColor};
    border-width: ${(props) =>
        props.validationState === "error"
            ? formInputTheme.borderWidth.error(props.themeMode)
            : formInputTheme.borderWidth.rest(props.themeMode)}px;
    border-radius: ${(props) => (props.themeMode === "oldestar" ? 2 : 4)}px;
    background-color: ${getBackgroundColor};
    border-left-width: 0;
    border-right-width: 0;
    border-radius: 0;
`;

function getBackgroundColor({ isDisabled, themeMode }: TextInputRootBoxProps) {
    if (isDisabled) {
        return formInputTheme.backgroundColor.readonly(themeMode);
    } else {
        return formInputTheme.backgroundColor.underlined(themeMode);
    }
}
